import React, { FC } from 'react';

interface NavSeparatorProps {
    text: string | React.ReactNode;
}

const NavSeparator: FC<NavSeparatorProps> = ({ text }) => {
    return (
        <div className="mx-3 my-2 text-sm">
            <span>{text}</span>
        </div>
    );
};

export default NavSeparator;
